import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import loadable from '@loadable/component';
import { FormattedMessage } from 'react-intl';
import { useSettings } from '../../context/SettingsContext/useSettings';

const Tools = loadable(() => import('./Tools').then((mod) => mod.Tools), {
  ssr: false,
});

const accordionStyles = {
  bgcolor: 'transparent',
  backgroundImage: 'none',
  border: '1px solid transparent',
  borderRadius: '7px !important',
  boxShadow: 'none',
  overflow: 'hidden',
  '&:before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    m: 0,
    bgcolor: 'background.paper',
    borderColor: 'softBorder',
  },
};
const accordionContentStyles = { px: 1.5, pt: 1.5, pb: 1.75 };
const summaryStyles = {
  minHeight: 40,
  px: 1.5,
  py: 0,
  bgcolor: 'navItem.hoverBackground',
  fontSize: 14,
  fontWeight: 500,
  '&.Mui-expanded': {
    minHeight: 40,
    bgcolor: 'navItem.activeBackground',
  },
  '& .MuiAccordionSummary-content': {
    my: 1,
  },
  '& .MuiAccordionSummary-content.Mui-expanded': {
    my: 1,
  },
};
const summaryContentStyles = { color: 'text.primary' };
const settingsIconStyles = { color: 'text.secondary', fontSize: 18 };

const FindLayersSettings = () => {
  const {
    store: { findSettingsExpanded },
    setFindSettingsExpanded,
  } = useSettings();
  const handleChange = (_event: React.SyntheticEvent, expanded: boolean) => {
    setFindSettingsExpanded(expanded);
  };

  return (
    <Accordion
      disableGutters
      expanded={findSettingsExpanded}
      onChange={handleChange}
      sx={accordionStyles}
      elevation={0}
    >
      <AccordionSummary
        sx={summaryStyles}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
          sx={summaryContentStyles}
        >
          <TuneRoundedIcon sx={settingsIconStyles} />
          <FormattedMessage id="map.findSettings" defaultMessage="Settings" />
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={accordionContentStyles}>
        <Tools />
      </AccordionDetails>
    </Accordion>
  );
};

export { FindLayersSettings };
